import { useEffect, useState, useRef } from 'react';
import { Style, Fill } from 'ol/style';
import OLVectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import WKT from 'ol/format/WKT';
import Feature from 'ol/Feature';
import Cspline from 'ol-ext/render/Cspline'; // eslint-disable-line
import filters from '../filters.module.css';

function MaskLayer({
  map, id, polygon, source, blur = 0, zIndex = 1, opacity = 1, smoothing = 0,
}) {
  const [maskLayer, setMaskLayer] = useState(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (!map) return undefined;

    // If we already have a layer, just update its properties
    if (layerRef.current) {
      if (polygon || source) {
        if (polygon) {
          const format = new WKT();
          const wkt = format.readGeometry(polygon, { 
            dataProjection: 'EPSG:4326', 
            featureProjection: 'EPSG:3857' 
          });
          const feature = new Feature(wkt);
          feature.setGeometry(feature.getGeometry());
          layerRef.current.getSource().clear();
          layerRef.current.getSource().addFeature(feature);
        }
        layerRef.current.setZIndex(zIndex);
        layerRef.current.setOpacity(opacity);
        layerRef.current.set('className', `${filters.blur} ${filters[`blur${blur}`]}`);
        return undefined;
      }
    }

    // Create new layer if it doesn't exist
    const style = new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 1)',
      }),
    });

    const vectorLayer = new OLVectorLayer({
      source: source || new VectorSource(),
      style,
      className: `${filters.blur} ${filters[`blur${blur}`]}`,
      id,
      opacity,
      zIndex,
      renderBuffer: Math.round(smoothing * 100),
      updateWhileAnimating: true,
      updateWhileInteracting: true
    });

    // Add layer to map if we have either a polygon or source
    if (polygon || source) {
      if (polygon) {
        const format = new WKT();
        const wkt = format.readGeometry(polygon, { 
          dataProjection: 'EPSG:4326', 
          featureProjection: 'EPSG:3857' 
        });
        const feature = new Feature(wkt);
        feature.setGeometry(feature.getGeometry());
        vectorLayer.getSource().addFeature(feature);
      }
      
      map.addLayer(vectorLayer);
      vectorLayer.setZIndex(zIndex);
      vectorLayer.setOpacity(opacity);
      setMaskLayer(vectorLayer);
      layerRef.current = vectorLayer;
    }

    return () => {
      if (map && layerRef.current) {
        map.removeLayer(layerRef.current);
        layerRef.current = null;
      }
    };
  }, [map, id, polygon, source, smoothing, opacity, zIndex, blur]);

  return null;
}

export default MaskLayer;
